// extracted by mini-css-extract-plugin
export default {"register":"register_register__CCSF3","loginLink":"register_loginLink__k+nGQ"};